import type { ChangelogEntry } from "../types";

/** «Ny kunde» på /kunder, og duplikatvern i kundedialogen. */
export const NY_KUNDE_2026_10: ChangelogEntry = {
  id: "2026-10-23-ny-kunde",
  date: "2026-10-23",
  title: "Opprett kunder rett fra kundelisten",
  summary:
    "Kundelisten har fått knappen «Ny kunde», og kundedialogen sier fra når kunden finnes fra før, så du ikke lager en dublett som ikke kan faktureres.",
  sections: [
    {
      heading: "Kunder",
      minRole: "user",
      items: [
        {
          title: "«Ny kunde» i kundelisten",
          kind: "nytt",
          body: "Øverst til høyre i kundelisten. Samme skjema som når du lager kunde fra et nytt prosjekt eller tilbud, med søk i Brønnøysund. Etter opprettelsen kommer du rett til kundekortet. Knappen vises for administratorer og prosjektledere eller rådgivere.",
        },
        {
          title: "Kunden som eier",
          kind: "nytt",
          featureFlag: "feature_crm_kundekort",
          body: "«Sett meg som kundeeier» er huket av som standard, så nye kunder ikke havner under «Uten eier».",
        },
        {
          title: "Varsel når kunden finnes fra før",
          kind: "rettet",
          body: "Skriver du et organisasjonsnummer som allerede er kunde, kan du ikke opprette en ny. Du får i stedet valget «Bruk denne kunden» (fra prosjekt og tilbud) eller «Åpne kundekortet» (fra kundelisten). Før ble dubletten opprettet, men ikke koblet til PowerOffice. Samme navn gir bare et varsel.",
        },
      ],
    },
  ],
};
